module.exports = __webpack_public_path__ + "static/media/white.0cddcdc4.png";